<template>
	<div class="container-list">
		<el-form>
			<el-form-item label="数据来源:">
				<el-col :span="4">
					<el-select v-model="type">
						<el-option :value="1" label="检查隐患"></el-option>
						<el-option :value="2" label="巡查隐患"></el-option>
					</el-select>
				</el-col>
			</el-form-item>
		</el-form>

		<danger :c_num="$route.query.id" v-if="type == 1"></danger>
		<safeRescured :c_num="$route.query.id" v-if="type == 2"></safeRescured>
	</div>
</template>

<script>
	import danger from "../../company/danger";
	import safeRescured from "./safeRescured.vue";
	export default {
		data() {
			return {
				type: 1,
			};
		},
		components: { danger, safeRescured },
		props: ["c_num"],
		watch: {
			c_num(val) {
				if (val) {
					this.params.c_company_num = val;
				}
			},
			dangerDia(val) {
				if (!val) {
					this.resetDanger();
				}
				if (val) {
					setTimeout(() => {
						var divs = document.getElementsByClassName("el-upload--picture-card");

						divs[0].style.display = this.editable ? "block" : "none";
					}, 1);
				}
			},
		},
		created() {},
		methods: {
			//新增安全隐患
			// 图片预览
		},
	};
</script>

<style scoped></style>
